/**
 * Utilidades para clases CSS de drag and drop
 * Compatible con el patrón existente de useDragDrop.js
 */

import { normalizeTransform } from './eventNormalizer';

/**
 * Genera clases CSS para contenedores droppable
 * @param {Object} state - Estado del droppable
 * @param {boolean} state.isOver - Si hay un elemento sobre el droppable
 * @returns {string} Clase CSS
 */
export function getListClass(state) {
  const { isOver } = state || {};
  return isOver ? 'is-dragging-over' : '';
}

/**
 * Genera clases CSS para items draggables
 * @param {Object} state - Estado del draggable
 * @param {boolean} state.isDragging - Si el elemento está siendo arrastrado
 * @returns {string} Clase CSS
 */
export function getItemClass(state) {
  const { isDragging } = state || {};
  return isDragging ? 'is-dragging' : '';
}

/**
 * Combina múltiples clases CSS de forma segura
 * @param {...string} classes - Clases a combinar
 * @returns {string} Clases combinadas
 */
export function cx(...classes) {
  return classes.filter(Boolean).join(' ');
}

/**
 * Genera estilos de transformación para el drag
 * @param {Object} transform - Objeto transform (independiente de librería)
 * @param {Object} transition - Transición
 * @returns {Object} Estilos CSS
 */
export function getDragStyle(transform, transition) {
  const normalized = normalizeTransform(transform);
  
  return {
    transform: normalized 
      ? `translate3d(${normalized.x}px, ${normalized.y}px, 0)` 
      : undefined,
    transition,
  };
}
